/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ViewsInputs */

const en_views = /** @type {(inputs: ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Views`)
};

const es_views = /** @type {(inputs: ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vistas`)
};

const fr_views = /** @type {(inputs: ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vues`)
};

const de_views = /** @type {(inputs: ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufrufe`)
};

const ja_views = /** @type {(inputs: ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閲覧数`)
};

const zh_views = /** @type {(inputs: ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览量`)
};

const ar_views = /** @type {(inputs: ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المشاهدات`)
};

const id_views = /** @type {(inputs: ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tayangan`)
};

const it_views = /** @type {(inputs: ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizzazioni`)
};

const ru_views = /** @type {(inputs: ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Просмотры`)
};

const pt_views = /** @type {(inputs: ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizações`)
};

const ko_views = /** @type {(inputs: ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`조회수`)
};

/**
* | output |
* | --- |
* | "Views" |
*
* @param {ViewsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const views = /** @type {((inputs?: ViewsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ViewsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_views(inputs)
	if (locale === "es") return es_views(inputs)
	if (locale === "fr") return fr_views(inputs)
	if (locale === "de") return de_views(inputs)
	if (locale === "ja") return ja_views(inputs)
	if (locale === "zh") return zh_views(inputs)
	if (locale === "ar") return ar_views(inputs)
	if (locale === "id") return id_views(inputs)
	if (locale === "it") return it_views(inputs)
	if (locale === "ru") return ru_views(inputs)
	if (locale === "pt") return pt_views(inputs)
	return ko_views(inputs)
});